// import {ajaxAxiosGetP} from '../libs/ajax'
// import {getCurrentApiHost} from '../libs/utils'
import {getRequest} from './hybrid_api'

export function getUploadToken () {
  return getRequest('/upload_token')
  // return ajaxAxiosGetP(`${getCurrentApiHost()}/v2/upload_token`, {})
}



// WEBPACK FOOTER //
// ./src/services/common_api.js